const FORM = {
  DESKTOP_TEXT_AREA_LINE_HEIGHT: 38,
  SUCCESS_MESSAGE_TIMEOUT: 2000,
  BUTTON_STATE: {
    SUCCESS: 'success',
    ERROR: 'error',
    LOADING: 'loading',
  },
};

export default FORM;



// WEBPACK FOOTER //
// ./src/common/consts/form.js